import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn } from '@angular/router';
import { OrderCheckoutService } from '../../order-checkout/order-checkout.service';
import { restoreCartItemsAndGoToResume } from './restore-cart-items';

export const repeatOrderGuardFn: CanActivateFn = (routeSnapshot: ActivatedRouteSnapshot) => {
  const orderCheckoutService = inject(OrderCheckoutService);
  const { orderId } = routeSnapshot.params;

  return restoreCartItemsAndGoToResume(orderId, establishmentId =>
    orderCheckoutService.getOrderCartItems(orderId, establishmentId),
  );
};
